import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ActivityStatusEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import "../../../moreCore/UI/ColorPicker/ColorPicker";

class ActivityStatusEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;


    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        this.entityClass = MainCatalogs_Classes.EvActivityStatus;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ActivityStatusEditorV2);